import { TextField } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const AddDamagedSectionDescription = ({
  descriptionInput,
  handleDescriptionChange,
}) => {
  const { t } = useTranslation()

  return (
    <TextField
      variant="outlined"
      label={t('damage_registration_page.optional')}
      helperText={`${descriptionInput.length}/300`}
      value={descriptionInput}
      InputLabelProps={{
        sx: (theme) => ({ color: theme.palette.text.darkSecondary }),
      }}
      FormHelperTextProps={{
        sx: (theme) => ({
          color: theme.palette.text.darkSecondary,
          textAlign: 'right',
        }),
      }}
      onChange={(e) => handleDescriptionChange(e)}
    />
  )
}

export default AddDamagedSectionDescription
